// src/stores/featureStore.ts
import { create } from 'zustand';
import type { FeatureFlags } from '@/lib/features/featureFlags';
import type { ExposureFlags } from '@/lib/features/featureFlags';

interface FeatureState {
  featureFlags: FeatureFlags | null;
  setFeatureFlags: (flags: FeatureFlags) => void;
  exposureFlags: ExposureFlags | null;
  setExposureFlags: (flags: ExposureFlags) => void;
}

export const useFeatureStore = create<FeatureState>((set) => ({
  featureFlags: null,
  setFeatureFlags: (flags) => set({ featureFlags: flags }),
  exposureFlags: null,
  setExposureFlags: (flags) => set({ exposureFlags: flags }),
}));
